import { useGetIncidentQuery } from "@/graphql/generated"
import { useLocation, useNavigate } from "react-router"
import { NavTabsProps, NavTabsWithActions, PropertyTopBar } from "../molecules"
import { useEffect, useRef, useState } from "react"
import { LoadingSpinner } from "../atoms"
import { IncidentDetailTemplate } from "../templates"
import { useErrorHandlerContext, useIncidentDetailContext, useUserLanguage } from "@/customHooks"
import textsData from '@/textData/IncidentDetailTexts.json'
import { pathURL } from "@/components/constants/urls"



export const IncidentDetailPage = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.tabs : textsData.en.tabs

  const { incident, setIncident } = useIncidentDetailContext()
  const location = useLocation()
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState(location.state?.selectedTab ?? '1')

  const isInitialMount = useRef(true);

  const { open: errorHandle } = useErrorHandlerContext()

  useEffect(() => {
    if (!location.state?.id) {
      navigate(`/${pathURL.USER}`, { replace: true })
    }
  }, [location.state?.id, navigate])

  const {data, error, loading, refetch} = useGetIncidentQuery({ 
    variables: {
      incidentId: location.state?.id ?? ''
    },
    skip: !location.state?.id
  })

  const tabs: NavTabsProps[] = [
  {
    label: texts.tab1,
    id: '1'
  },
  {
    label: texts.tab2,
    id: '2'
  },
  {
    label: texts.tab3,
    id: '3'
  },
  {
    label: texts.tab4,
    id: '4'
  },
  {
    label: texts.tab5,
    id: '5'
  },
]

  useEffect(() => {
    if (data?.incident) {
      setIncident(data.incident);
    }
  }, [data, setIncident]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (incident === undefined && !loading) {
      refetch();
    }
  }, [incident, loading, refetch]);


  if (error) errorHandle(error)
  
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-16">
        <LoadingSpinner />
        <p className="text-sm">Loading...</p>
      </div>
    )
  }
  
  return (
    <>
      <PropertyTopBar
        name={data?.incident.property?.name ?? 'No name available'}
        address={{
          street: data?.incident.property?.address.street ?? '',
          buildingNumber: data?.incident.property?.address.buildingNumber ?? '',
          addressLine: data?.incident.property?.address.addressLine ?? '',
          city: data?.incident.property?.address.city?.name ?? '',
          state: data?.incident.property?.address.state?.name ?? '',
          country: data?.incident.property?.address.country?.name ?? '',
          zipCode: data?.incident.property?.address.zipCode ?? '',
        }}
      />
      <div className="w-full">
        <NavTabsWithActions
          tabs={tabs}
          onClick={setSelectedTab}
          selectedTabId={selectedTab}
        />
      </div>
      <div className="w-full max-w-none px-4 pb-8 pt-4 sm:px-6 lg:px-8">
        <IncidentDetailTemplate 
          selectedSection={selectedTab} 
          openChat={location.state?.openChat ?? false}
        />
      </div>
    </>
  )
}